import { getNetlifyFunctionsBase } from "./netlifyFunctions.js";

/**
 * Start Stripe checkout for the given verified email.
 * Redirects on success; throws on failure.
 * @param {string} verifiedEmail
 * @param {{ billingInterval?: 'month' | 'year' }} [options]
 */
export async function startCheckout(verifiedEmail, options = {}) {
  if (!verifiedEmail) {
    throw new Error("Login required.");
  }
  const billingInterval = options.billingInterval === "year" ? "year" : "month";
  const response = await fetch(`${getNetlifyFunctionsBase()}/.netlify/functions/createCheckoutSession`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: verifiedEmail, billingInterval })
  });
  if (!response.ok) {
    const errText = await response.text();
    throw new Error(errText || "Unable to start checkout.");
  }
  const data = await response.json();
  if (data?.url) {
    window.location.href = data.url;
    return;
  }
  throw new Error("No checkout URL received");
}
